import { BaseValidationRule, IValidateable } from '@aurelia/validation';

export class AbnSelectedPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super();
  }

  public execute(value: any, _object?: IValidateable): boolean {
    return _object.selectedResult !== null && Object.keys(_object.selectedResult).length > 0;
  }
}
